import operationsRootRoute from './operations-root-route'
import operationsHistoricalDetailRoute from './operations-historical-detail-route'

export default () => [
  operationsRootRoute(),
  operationsHistoricalDetailRoute(),
]
